import { InjectionToken } from '@angular/core';

export const CDN_URL = new InjectionToken<string>('CDN_URL', {
    factory: () => {
        throw new Error(
            'CDN_URL token is not provided. Add `{ provide: CDN_URL, useValue: environment.fileManagerCdnUrl }` to your app providers.'
        );
    },
});
export const PREFER_RESIZED_PREVIEW = new InjectionToken<boolean>('PREFER_RESIZED_PREVIEW', {
    providedIn: 'root',
    factory: () => false,
});
